import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

type Result = {
	formatValue: (value: number) => string;
	formatTooltipValue: (value: number) => string;
};

export function useAmountFormatters(currencyCode: string): Result {
	const { localizeCurrency } = useI18n();

	const formatValue = useCallback(
		(value: number) =>
			localizeCurrency(value, currencyCode, {
				currencyDisplay: 'narrowSymbol',
				notation: 'compact',
			}),
		[currencyCode, localizeCurrency],
	);

	const formatTooltipValue = useCallback(
		(value: number) =>
			localizeCurrency(value, currencyCode, {
				currencyDisplay: 'narrowSymbol',
			}),
		[currencyCode, localizeCurrency],
	);

	return { formatValue, formatTooltipValue };
}
